import { action as apiAction } from 'api/Api'
import {
  addLabel as addLabelToCard
} from '../redux/cards'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  id: number
  labelId: number
}

export default (payload: Payload) => async (dispatch, getState) => {
  const { id, labelId } = payload

  const state = getState()

  const card = state['view-board'].cards[id]

  if (!card || card.labels.indexOf(labelId) !== -1) return

  const optimisticAction = optimisticDispatch(dispatch, addLabelToCard({
    id,
    labelId,
    index: undefined
  }))

  try {
    await apiAction('AddLabelToCard', {
      cardId: id,
      labelId
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    if (error.code !== 303) { // NoChange
      throw error
    }
  }
}
